import { useMemo, useState } from 'react';
import { Tooltip } from '@primer/react';

import Button from '../common/Button/Button';
import ContextualAssayCreationFrame from './AssayCreationModal';
import ModalOverlay from '../common/ModalOverlay/ModalOverlay';


export const AssayCreationButton = ({ disable, inferenceData }) => {
  const [show, setShow] = useState(false);

  const renderHoverText = useMemo(() => {
    if (disable) {
      return (
        <Tooltip aria-label="No inference(s) available">
          <Button variant="primary" onClick={() => setShow(true)} disabled={disable}>
            + Create Assay
          </Button>
        </Tooltip>
      )
    }

    return (
      <Button variant="primary" onClick={() => setShow(true)} disabled={disable}>
        + Create Assay
      </Button>
    )
  }, [disable])

  return <>
    {renderHoverText}
    {show && <ModalOverlay active={show} onModalToggle={() => setShow(false)}>
      <div style={{ width: '800px', height: '600px' }}>
        <ContextualAssayCreationFrame onClose={() => setShow(false)} inferenceData={inferenceData} />
      </div>
    </ModalOverlay>
    }
  </>
};

export default AssayCreationButton;
